import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { IconSprite } from '@voice/ui-tokens';
import type { ReactNode } from 'react';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Mobil tarmoqda har fokusda qayta so'rov — ortiqcha trafik va sekinlik.
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 30_000,
    },
  },
});

export function Providers({ children }: { children: ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      {/* Sprite ilova ildizida BIR MARTA — barcha <use href="#ic-*"/> shundan. */}
      <IconSprite />
      <div className="ambient" />
      {children}
    </QueryClientProvider>
  );
}

export { queryClient };
